import { FlattenedOrderStatuses } from '@sg/graphql-schema';

import type { OrderStatusMapProps } from '../types';

export const filterPropsByOrderType = (props: OrderStatusMapProps): OrderStatusMapProps => {
  const {
    orderType,
    orderStatus,
    locationName,
    locationLatitude,
    locationLongitude,
    customerName,
    customerLatitude,
    customerLongitude,
    deliveryAddressName,
    deliveryAddressType,
    deliveryAddressLatitude,
    deliveryAddressLongitude,
    courierName,
    courierLatitude,
    courierLongitude,
  } = props;

  if (orderType === 'pickup' || orderType === 'in-store') {
    return {
      orderType,
      locationName,
      locationLatitude,
      locationLongitude,
      customerName,
      customerLatitude,
      customerLongitude,
    };
  }

  if (orderType === 'outpost') {
    return {
      orderType,
      locationName,
      locationLatitude,
      locationLongitude,
    };
  }

  if (orderStatus === FlattenedOrderStatuses.Delivering) {
    return {
      orderType,
      deliveryAddressName,
      deliveryAddressType,
      deliveryAddressLatitude,
      deliveryAddressLongitude,
      courierName,
      courierLatitude,
      courierLongitude,
    };
  }

  return {
    orderType,
    deliveryAddressName,
    deliveryAddressType,
    deliveryAddressLatitude,
    deliveryAddressLongitude,
  };
};
